module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'p3oh0ot7',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
